// @ts-nocheck
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import './override-leaflet.css'

import * as esri from 'esri-leaflet'
import proj4leaflet from 'proj4leaflet'

// 解决marker图片请求失败的问题
import icon from 'leaflet/dist/images/marker-icon.png'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'

import '@/components/main-map/libs/Leaflet.NavBar.js'

import './tiandituLayer'
import './leaflet.ChineseTmsProviders'

import './L.Icon.Pulse.css'
import './L.Icon.Pulse.js'

window.L.Esri = esri
window.L.esri = esri
window.L.Esri.Proj = proj4leaflet

const DefaultIcon = window.L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [13, 18]
})
window.L.Marker.prototype.options.icon = DefaultIcon
